import { Injectable, signal, computed, Signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RequestStatusService {
  private readonly _activeRequestsCount = signal<number>(0);
  private readonly hasErrorOccurred = signal<boolean>(false);

  readonly requestStatus = computed(() =>
    this._activeRequestsCount() > 0 ? 'pending' : 'resolved',
  );

  incrementActiveRequests(): void {
    this._activeRequestsCount.update((count) => count + 1);
  }

  decrementActiveRequests(): void {
    this._activeRequestsCount.update((count) => Math.max(0, count - 1));
  }

  getActiveRequestsCount(): number {
    return this._activeRequestsCount();
  }

  setErrorOccurred(hasError: boolean): void {
    this.hasErrorOccurred.set(hasError);
  }

  getErrorOccurred(): Signal<boolean> {
    return this.hasErrorOccurred;
  }
}
